import React from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Handle, Position } from "@xyflow/react";
import { FlowElementsContextProvider } from "../../FlowElements/FlowElementsContextProvider";
import "./AssignNode.scss";
import NodeAssignment from "./NodeAssignment";

const AssignNode = ({ data, id }) => {
  return (
    <div className={`assign-node ${data?.isCompleted ? 'node-completed' : ''}`}>
      <Tooltip position='bottom' anchorElement='target' parentTitle={true}>
        <div title='Input'>
          <Handle type='target' position={Position.Top} />
        </div>
      </Tooltip>
                               
      <div className='node-content'>
        <FlowElementsContextProvider>
          <NodeAssignment nodeId={id} nodeData={data?.workflowElements?.[0] || null} onDeleteNode={data.onDeleteNode} onUpdateNodeData={data.onUpdateNodeData} isReadOnly={data.isReadOnly} isCompleted={!!data.isCompleted} />
        </FlowElementsContextProvider>
      </div>
      <Tooltip position='left' anchorElement='target' parentTitle={true}>
        <div title='Event trigger on assignment'>
          <Handle type='source' position={Position.Right} id='right' />
        </div>
      </Tooltip>
      <Tooltip position='bottom' anchorElement='target' parentTitle={true}>
        <div title='Event trigger on completion'>
          <Handle type='source' position={Position.Bottom} id='bottom' />
        </div>
      </Tooltip>
    </div>
  );
};

export default AssignNode;
